import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AppRouter from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';

const queryClient = new QueryClient();

function App() {
  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
